<div class="row mb-1" *ngIf="!gestionTerceros">
    <div class="col-8">
        <!-- boton gestion OR -->
        <!-- 1 opcion -->

        <button [disabled]="desactivarBotonGOR" type="button" class="btn btn-secondary btn-sm ml-1"
            (click)="gestionOR()">
            {{'labels.gestion_or' | translate}}
            <i class="fa fa-paste"></i>
        </button>


        <!-- 1 opcion -->
        <button (click)="recepcionVehiculo()" type="button" class="btn btn-secondary">
            <i class="fa fa-car"></i>
            {{'labels.recepcion_vehiculos'| translate}}
        </button>

        <!-- Solo para gestion terceros -->
        <button type="button" *ngIf="gestionTerceros" (click)="cancelarOut()" class="btn btn-info">
            <i class="fa fa-ban">
            </i> {{'labels.cancelar' | translate}}
        </button>

    </div>

    <!-- busqueda de iIntervenciones -->
    <div class="col-4 reset">
        <form [formGroup]="searchForm">

            <div class="form-group row mr-1 ">
                <label appCurrentColor class="col-6 col-form-label mt-2 mr-1 p-0 text-right mr-1 text-not-over">
                    {{'gestion_vehiculos.formLabel.historicalInterventions' | translate}} :</label>
                <input type="text" placeholder="Buscar..." formControlName="searchValue"
                    class="form-control form-control-sm  col-4 mt-1">
                <span class="input-group-addon  cursor p-1 mt-1">
                    <i class="k-icon k-i-search" (click)="search('lupa')" appCurrentColor></i>
                </span>
            </div>


        </form>
    </div>

</div>

<div class="row mb-1" *ngIf="gestionTerceros">

    <div class="col-5">
        <button type="button" (click)="cancelarOut()" class="btn btn-info">
            <i class="fa fa-ban" aria-hidden="true">
            </i> {{'labels.cancelar' | translate}}
        </button>
    </div>

    <div class="col-7">
        <form [formGroup]="searchForm">
            <div class="form-group row mr-1 ">
                <label appCurrentColor class="col-6 col-form-label mt-2 mr-1 p-0 text-right mr-1 text-not-over">
                    {{'gestion_vehiculos.formLabel.historicalInterventions' | translate}} :</label>
                <input type="text" placeholder="Buscar..." formControlName="searchValue"
                    class="form-control form-control-sm  col-4 mt-1">
                <span class="input-group-addon  cursor p-1 mt-1">
                    <i class="k-icon k-i-search" (click)="search()" appCurrentColor></i>
                </span>
            </div>
        </form>
    </div>

</div>


<div [ngSwitch]="vistaNavigate">

    <div *ngSwitchCase="1">
        <div class="row">

            <div class="col-12">
                <!-- tabla de selccion de OR -->
                <kendo-grid (cellClick)="selectOr($event,'tabla')" [selectable]="true" [data]="ordenRep[0].gridView"
                    [height]="ordenRep[0].height" [resizable]='true' [pageSize]="pageSizeOR" [skip]="skipOR"
                    [pageable]="true" (pageChange)="pageChangeOR($event)">

                    <kendo-grid-column *ngFor="let th of ordenRep[0].th;let i=index" title="{{th | translate }}"
                        field="{{ordenRep[0].fields[i]}}">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <span title="{{th | translate}}">{{th | translate}}</span>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span title="{{dataItem[ordenRep[0].fields[i]]}}">{{dataItem[ordenRep[0].fields[i]]}}</span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-messages pagerOf="{{ 'genericos.messagesKendo.of' | translate }}"
                        pagerItemsPerPage="{{ 'genericos.messagesKendo.ElementosPagina' | translate }}"
                        pagerItems="{{ 'genericos.messagesKendo.ElementosMostrados' | translate }}">>
                    </kendo-grid-messages>

                    <ng-template id="pagerTemplate" kendoPagerTemplate let-totalPages="objetoPaginacionOR.TotalPages"
                        let-currentPage="currentPage">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons [buttonCount]="kendoPagerSettings.buttonCount">
                        </kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        <kendo-pager-info> </kendo-pager-info>
                    </ng-template>
                    <ng-template kendoGridNoRecordsTemplate>
                        {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                    </ng-template>
                </kendo-grid>
            </div>
        </div>

        <div class="row">
            <div class="col-4">
                <div class="row">
                    <div class="col-12">
                        <label appCurrentColor class="col-form-label reset text-bold">
                            {{ 'gestion_vehiculos.lRecepcion' | translate }}: </label>
                        <kendo-grid *ngIf="!isLoadin123" [data]="lRecepcion[0].gridView"
                            [height]="lRecepcion[0].height">
                            <kendo-grid-column *ngFor="let th of lRecepcion[0].th;let i=index"
                                title="{{th | translate}}" field="{{lRecepcion[0].fields[i]}}">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    <span title="{{th | translate}}">{{th | translate}}</span>
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span
                                        title="{{_globals.getLabel(dataItem,lRecepcion[0].fields[i] )}}">{{_globals.getLabel(dataItem,lRecepcion[0].fields[i] )}}</span>
                                </ng-template>
                            </kendo-grid-column>
                            <ng-template kendoGridNoRecordsTemplate>
                                {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                            </ng-template>
                        </kendo-grid>
                        <div *ngIf="isLoadin123" class="kendo-loading">
                            <span class="k-icon k-i-loading"></span>
                        </div>

                    </div>


                    <div class="col-12 ">

                        <label appCurrentColor class="col-form-label reset text-bold">
                            {{ 'labels.facturas' | translate }}: </label>
                        <kendo-grid *ngIf="!isLoadin123" [data]="facturas[0].gridView" [height]="facturas[0].height"
                            (edit)="editHandler($event)">
                            <kendo-grid-column *ngFor="let th of facturas[0].th;let i=index" title="{{th | translate}}"
                                field="{{facturas[0].fields[i]}}">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    <span title="{{th | translate}}">{{th | translate}}</span>
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span
                                        title="{{dataItem[facturas[0].fields[i]]}}">{{dataItem[facturas[0].fields[i]]}}</span>
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-command-column title="" width="50">
                                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

                                    <button kendoGridEditCommand type="button" class="invoiceDetailList-btn p-0">
                                        <span class="k-icon k-i-redo color_blue"></span>
                                    </button>

                                </ng-template>
                            </kendo-grid-command-column>
                            <ng-template kendoGridNoRecordsTemplate>
                                {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                            </ng-template>

                        </kendo-grid>
                        <div *ngIf="isLoadin123" class="kendo-loading">
                            <span class="k-icon k-i-loading"></span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-8 pl-1">
                <label appCurrentColor class="col-form-label reset text-bold">
                    {{ 'gestion_vehiculos.lImputacion' | translate }}: </label>
                <kendo-grid *ngIf="!isLoadin123" class="mt-0 p-0" [data]="lInputacion[0].gridView" [resizable]='true'
                    [height]="lInputacion[0].height">
                    <kendo-grid-column *ngFor="let th of lInputacion[0].th;let i=index"
                        field="{{lInputacion[0].fields[i]}}" title="{{th | translate}}"
                        width="{{lInputacion[0].width[i]}}">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <span title="{{th | translate}}">{{th | translate}}</span>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span
                                title="{{dataItem[lInputacion[0].fields[i]]}}">{{dataItem[lInputacion[0].fields[i]]}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <ng-template kendoGridNoRecordsTemplate>
                        {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                    </ng-template>
                </kendo-grid>

                <div *ngIf="isLoadin123" class="kendo-loading">
                    <span class="k-icon k-i-loading"></span>
                </div>


            </div>
        </div>

    </div>

    <!-- Tabla historico de intervenciones  mas botones de impresora y cancelar *ngSwitchCase="2"-->
    <div class="row justify-content-end" *ngSwitchCase="2">

        <div class="col-2 mt-1 mb-1 text-new-14">
            <i class="color_red fa fa-times float-left mr-2" [ngStyle]="{'margin-left':'5px', 'cursor':'pointer'}"
                (click)="vistaNavigate = 1" aria-hidden="true"></i>
            <i class="color_blue fa fa-print float-left" (click)="printInforme()"
                [ngStyle]="{'margin-left':'5px', 'cursor':'pointer'}" aria-hidden="true"></i>
        </div>



        <!--Tabla de historico -->
        <div class="col-12">
            <kendo-grid *ngIf="!isLoadingSearch" class="mt-0 p-0" [data]="history[0].gridView"
                [height]="history[0].height" [resizable]='true' [pageSize]="pageSizeH" [skip]="skipH" [pageable]="true"
                (pageChange)="pageChangeH($event)">
                <kendo-grid-column *ngFor="let th of history[0].th;let i=index" field="{{history[0].fields[i]}}"
                    title="{{ th | translate}}">
                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                        <span title="{{th | translate}}">{{th | translate}}</span>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span title="{{dataItem[history[0].fields[i]]}}">{{dataItem[history[0].fields[i]]}}</span>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-messages pagerOf="{{ 'genericos.messagesKendo.of' | translate }}"
                    pagerItemsPerPage="{{ 'genericos.messagesKendo.ElementosPagina' | translate }}"
                    pagerItems="{{ 'genericos.messagesKendo.ElementosMostrados' | translate }}">>
                </kendo-grid-messages>

                <ng-template id="pagerTemplate" kendoPagerTemplate let-totalPages="objetoPaginacion.TotalPages"
                    let-currentPage="currentPage">
                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                    <kendo-pager-numeric-buttons [buttonCount]="kendoPagerSettings.buttonCount">
                    </kendo-pager-numeric-buttons>
                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    <kendo-pager-page-sizes [pageSizes]="[5, 10, 20]">
                    </kendo-pager-page-sizes>
                    <kendo-pager-info> </kendo-pager-info>

                </ng-template>
                <ng-template kendoGridNoRecordsTemplate>
                    {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                </ng-template>


            </kendo-grid>
            <div *ngIf="isLoadingSearch" class="kendo-loading">
                <span appCurrentColor class="k-icon k-i-loading big"></span>
            </div>
        </div>
    </div>

</div>
